<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Cuenta
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="account_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import colabsService from '@/services/colaborators'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'AccountCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      account_details: {
        colaborator_id: {
          name: 'Colaborador',
          hint: 'Selecciona un Colaborador',
          type: 'select',
          options: [],
          size: 12,
          validate: 'required'
        },
        start_date: {
          name: 'Fecha Inicio',
          value: '',
          type: 'date'
        },
        salary: {
          name: 'Salario',
          hint: 'Salario',
          value: 0,
          type: 'number'
        },
        action_value: {
          name: 'Valor Acción',
          hint: 'Valor Acción',
          value: 0,
          type: 'number'
        },
        amount: {
          name: 'Monto Acumulado',
          hint: 'Monto Acumulado',
          value: 0,
          type: 'number'
        },
        restore_amount: {
          name: 'Saldo Pasado',
          hint: 'Saldo Pasado',
          value: 0,
          type: 'number'
        },
        previous_amount: {
          name: 'Saldo Anterior',
          hint: 'Saldo Anterior',
          value: 0,
          type: 'number'
        },
        percent: {
          name: 'Porcentaje',
          hint: 'Porcentaje',
          value: 0,
          type: 'number'
        },
        status: {
          name: 'Estatus',
          type: 'select',
          value: { value: 'Activo', text: 'Activo' },
          options: [
            { value: 'Activo', text: 'Activo' },
            { value: 'Inactivo', text: 'Inactivo' }
          ]
        },
        extra: {
          name: '¿Aplica extra?',
          type: 'select',
          value: { value: 0, text: 'No' },
          options: [
            { value: 0, text: 'No' },
            { value: 1, text: 'Sí' }
          ]
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    const id = this.$route.params.id
    colabsService.listSelect().then(res => {
      this.account_details.colaborator_id.options = res.data.map(data => {
        if (data.id == id) {
          this.account_details.colaborator_id.value = { value: data.id, text: `${data.name}` }
        }
        return { value: data.id, text: `${data.name}` }
      })
      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let id = this.$route.params.id
          let accountInfo = { ...this.account_details }

          let body = this.processForm(accountInfo)
          let service = colabsService.addAccount(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'colaborator', params: { id: id } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/colaborators/accounts/AccountCreate.vue